import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    formConfigId: '',
  },
  mutations: {
    setFormConfigId(state, formConfigId) {
      state.formConfigId = formConfigId
    },
  },
  actions: {},
  modules: {},
})
